import usePageTitle from "../../core/hooks/UsePageTitle";
import DefaultLayout from "../layouts/default/Default.layout";
import { Col, Form, Input, Row, Button, Modal, notification } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Materia } from "../../sdk/@types";
import MateriaService from "../../sdk/services/MateriaService";
import Table from "../components/Table/Table";
import useMaterias from "../../core/hooks/UseMaterias";
import useUsuario from "../../core/hooks/UseUsuario";
import { Column, useTable } from "react-table";
import { useMemo, useState, useEffect } from "react";

export default function MateriaForm() {
  const [form] = Form.useForm<Materia.Materia>();
  const [editingId, setEditingId] = useState<string | null>(null);
  usePageTitle("Matéria");
  const { materias, fetchMaterias } = useMaterias();
  const { usuario } = useUsuario();
  const isMaster = usuario?.profile === "master";

  useEffect(() => { fetchMaterias(); }, []);

  const handleEdit = (materia: Materia.Materia) => {
    setEditingId(materia.id ?? null);
    form.setFieldsValue({ name: materia.name });
  };

  const handleDelete = (materia: Materia.Materia) => {
    Modal.confirm({
      title: "Excluir matéria",
      content: `Deseja realmente excluir "${materia.name}"?`,
      okText: "Excluir",
      okType: "danger",
      cancelText: "Cancelar",
      centered: true,
      onOk: async () => {
        try {
          await MateriaService.deletarMateria(materia.id!);
          notification.success({ message: "Matéria excluída com sucesso." });
          fetchMaterias();
        } catch {
          notification.error({ message: "Erro ao excluir matéria." });
        }
      },
    });
  };

  const columns: Column<Materia.Materia>[] = useMemo(() => [
    { Header: "Nome", accessor: "name" },
    {
      Header: "Ações",
      id: "acoes",
      Cell: ({ row }: any) => isMaster ? (
        <div className="flex gap-2">
          <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() => handleEdit(row.original)}
          >
            Editar
          </Button>
          <Button
            size="small"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(row.original)}
          >
            Excluir
          </Button>
        </div>
      ) : null,
    },
  ], [materias, isMaster]);

  const instance = useTable<Materia.Materia>({ columns, data: materias });

  const handleCancel = () => {
    setEditingId(null);
    form.resetFields();
  };

  return (
    <DefaultLayout>
      <div className="p-4">
        <Form
          form={form}
          onFinish={async (values: Materia.Materia) => {
            try {
              if (editingId) {
                await MateriaService.atualizarMateria({ ...values, id: editingId });
                notification.success({ message: "Matéria atualizada com sucesso." });
              } else {
                await MateriaService.inserirNovaMateria(values);
                notification.success({ message: "Matéria cadastrada com sucesso." });
              }
              fetchMaterias();
              form.resetFields();
              setEditingId(null);
            } catch {
              notification.error({ message: "Houve um erro." });
            }
          }}
          layout="vertical"
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col span={15}>
              <Form.Item label="Descrição da Matéria" name="name">
                <Input placeholder="Ex.: SISTEMA DE COMANDO DE INCIDENTES" maxLength={60} />
              </Form.Item>
            </Col>
            <Col span={24} className="flex gap-2">
              <Button type="primary" htmlType="submit">
                {editingId ? "Atualizar" : "Salvar"}
              </Button>
              {editingId && (
                <Button onClick={handleCancel}>Cancelar</Button>
              )}
            </Col>
            <Col span={24} style={{ marginTop: 20 }}>
              <Table instance={instance} />
            </Col>
          </Row>
        </Form>
      </div>
    </DefaultLayout>
  );
}
